// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"fe479dea","239":"9cab0510","455":"4ecc80a4","488":"d4f3692a"}[chunkId] + ".chunk.js";
};